import React from 'react';

const Social = ({color}) => {
	return (
		<div className='social'>
			<div className='social__wapp'>
				<a href='https://wa.me/573209377591' target='_blank' rel='noreferrer'>
					<svg width='34' height='34' viewBox='0 0 34 34' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M31.2195 7.78136C26.1719 -0.000257233 15.8665 -2.31371 7.87461 2.52351C0.0929863 7.36074 -2.43078 17.8764 2.61676 25.6581L3.03738 26.289L1.35487 32.5984L7.66429 30.9159L8.29524 31.3365C11.0293 32.8087 13.9737 33.65 16.9181 33.65C20.0728 33.65 23.2275 32.8087 25.9616 31.1262C33.7432 26.0787 36.0567 15.7733 31.2195 7.78136V7.78136ZM26.8029 23.9756C25.9616 25.2374 24.9101 26.0787 23.4379 26.289C22.5966 26.289 21.545 26.7096 17.3387 25.0271C13.7634 23.3446 10.819 20.6105 8.71586 17.4558C7.45398 15.9836 6.82304 14.0908 6.61272 12.198C6.61272 10.5154 7.24367 9.04325 8.29524 7.99168C8.71587 7.57105 9.13649 7.36074 9.55712 7.36074H10.6087C11.0293 7.36074 11.4499 7.36074 11.6603 8.20199C12.0809 9.25356 13.1325 11.7773 13.1325 11.9876C13.3428 12.198 13.3428 12.6186 13.1325 12.8289C13.3428 13.2495 13.1325 13.6702 12.9221 13.8805C12.7118 14.0908 12.5015 14.5114 12.2912 14.7217C11.8706 14.932 11.6603 15.3527 11.8706 15.7733C12.7118 17.0352 13.7634 18.2971 14.815 19.3486C16.0769 20.4002 17.3387 21.2415 18.8109 21.8724C19.2316 22.0827 19.6522 22.0827 19.8625 21.6621C20.0728 21.2415 21.1244 20.1899 21.545 19.7693C21.9657 19.3486 22.176 19.3486 22.5966 19.559L25.9616 21.2415C26.3823 21.4518 26.8029 21.6621 27.0132 21.8724C27.2235 22.5034 27.2235 23.3446 26.8029 23.9756V23.9756Z'
							fill={color}
						/>
					</svg>
				</a>
			</div>
			<div className='social__youtube'>
				<a href='https://www.youtube.com/channel/UCQcebHXtEHrKJS-myPijtrA' target='_blank' rel='noreferrer'>
					<svg width='34' height='35' viewBox='0 0 34 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							d='M19.7298 17.3009L15.7938 15.4643C15.4503 15.3048 15.1681 15.4836 15.1681 15.8639V19.3232C15.1681 19.7035 15.4503 19.8823 15.7938 19.7228L19.7281 17.8862C20.0733 17.725 20.0733 17.4621 19.7298 17.3009ZM16.9206 0.769867C7.62903 0.769867 0.0969238 8.30197 0.0969238 17.5936C0.0969238 26.8851 7.62903 34.4172 16.9206 34.4172C26.2122 34.4172 33.7443 26.8851 33.7443 17.5936C33.7443 8.30197 26.2122 0.769867 16.9206 0.769867ZM16.9206 24.4282C8.30899 24.4282 8.15827 23.6518 8.15827 17.5936C8.15827 11.5353 8.30899 10.7589 16.9206 10.7589C25.5322 10.7589 25.683 11.5353 25.683 17.5936C25.683 23.6518 25.5322 24.4282 16.9206 24.4282Z'
							fill={color}
						/>
					</svg>
				</a>
			</div>
			<div className='social__facebook'>
				<a href='https://www.facebook.com/carsocncplasma' target='_blank' rel='noreferrer'>
					<svg width='35' height='35' viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M0.773865 17.6875C0.773865 26.0517 6.84862 33.0069 14.7936 34.4172V22.2663H10.5877V17.5936H14.7936V13.8545C14.7936 9.64857 17.5036 7.31288 21.3366 7.31288C22.5507 7.31288 23.8602 7.49934 25.0743 7.68581V11.9857H22.9251C20.8684 11.9857 20.4015 13.0133 20.4015 14.3228V17.5936H24.8878L24.1406 22.2663H20.4015V34.4172C28.3465 33.0069 34.4212 26.0531 34.4212 17.6875C34.4212 8.38259 26.8506 0.769867 17.5976 0.769867C8.34452 0.769867 0.773865 8.38259 0.773865 17.6875Z'
							fill={color}
						/>
					</svg>
				</a>
			</div>
		</div>
	);
};

Social.defaultProps = {
	color: 'white',
};

export default Social;
